import { forwardRef, ReactElement, Ref } from 'react'
import { GroupBase } from 'react-select'
import CreatableSelect from 'react-select/creatable'
import clsx from 'clsx'

import { SelectOption } from 'Components/Select/Select.types'

import { SelectCreateableProps } from './SelectCreateable.types'

const ForwardSelectCreatable = <
  Option extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectCreateableProps<Option, IsMulti, Group>,
  ref: Ref<any>,
) => {
  const { className, ...selectProps } = props

  return (
    <CreatableSelect
      ref={ref}
      className={clsx(
        'CustomReactSelect ReactSelect ReactSelect--creatable',
        className,
      )}
      classNamePrefix="ReactSelect"
      {...selectProps}
    />
  )
}

// forwardRef can't use generics. Workaround:
// https://stackoverflow.com/a/58473012
export const SelectCreateable = forwardRef(ForwardSelectCreatable) as <
  Option extends SelectOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectCreateableProps<Option, IsMulti, Group> & { ref?: Ref<any> },
) => ReactElement
